// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code[data-v-b01f227e] {\n  width: 150px;\n  height: 150px;\n  float: left;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid black;\n  background-color: white;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
